/// Selection strategies ///
export var SELECTION_STRATEGY;
(function (SELECTION_STRATEGY) {
    SELECTION_STRATEGY[SELECTION_STRATEGY["RAY_SELECT"] = 0] = "RAY_SELECT";
    SELECTION_STRATEGY[SELECTION_STRATEGY["PROXIMITY_SELECT"] = 1] = "PROXIMITY_SELECT";
    /** @see: https://www.researchgate.net/publication/220901774_IntenSelect_Using_Dynamic_Object_Rating_for_Assisting_3D_Object_Selection */
    SELECTION_STRATEGY[SELECTION_STRATEGY["INTEN_SELECT"] = 2] = "INTEN_SELECT";
})(SELECTION_STRATEGY || (SELECTION_STRATEGY = {}));
/// Intersection tests between two collision shapes ///
export var CollisionShapePrimitive;
(function (CollisionShapePrimitive) {
    CollisionShapePrimitive[CollisionShapePrimitive["SPHERE"] = 0] = "SPHERE";
    CollisionShapePrimitive[CollisionShapePrimitive["CONE"] = 1] = "CONE";
})(CollisionShapePrimitive || (CollisionShapePrimitive = {}));
